import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'configuraciones/configuraciones-de-mascaras/';

/**
 * GET Tipos de Identificaciones
 * @returns {Promise<object[]>}
 */
export const getConfiguracionesDeMascaras = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET ConfiguracionDeMascaras
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getConfiguracionDeMascaras = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST ConfiguracionDeMascaras
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postConfiguracionDeMascaras = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH ConfiguracionDeMascaras
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchConfiguracionDeMascaras = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE ConfiguracionDeMascaras
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteConfiguracionDeMascaras = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
